import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetPartsDeliveryRunsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetPartsDeliveryRunsQuery = { __typename?: 'query_root', mobility_runs: Array<{ __typename?: 'mobility_runs', id: number, status: string, fulfillment_type?: string | null, departure_time?: string | null, expected_return_time?: string | null, parts_delivery?: { __typename?: 'parts_deliveries', id: number, vendor?: string | null, orchestration_status: string, delivery_status: string, fee_cents?: number | null, currency?: string | null, dropoff_eta?: string | null, tracking_url?: string | null, driver?: object | null, proof_of_delivery?: object | null, booked_at?: string | null, completed_at?: string | null, cancelation_reason?: string | null, last_error?: object | null, created_by?: string | null } | null, driver?: { __typename?: 'drivers', id: number, status: string, user?: { __typename?: 'users', display_name: string, phone?: string | null } | null } | null, scenario?: { __typename?: 'scenarios', id: number, bundletoscenarios: Array<{ __typename?: 'bundletoscenarios', bundle: { __typename?: 'bundles', id: number, status: string, offers: Array<{ __typename?: 'offers', id: number, status: string, driver: { __typename?: 'drivers', id: number, status: string, user?: { __typename?: 'users', display_name: string, phone?: string | null } | null } }> } }> } | null, vehicle?: { __typename?: 'mobility_vehicles', id: number, year?: number | null, make: string, model: string, license_plate?: string | null } | null, stops: Array<{ __typename?: 'mobility_stops', id: number, stop_order: number, status: string, address?: string | null, address_lat?: number | null, address_lng?: number | null, delivery_orders: Array<{ __typename?: 'delivery_orders', id: number, order_number: string, recipient_business: string, quantity: number, status: string, delivery_status?: string | null }> }>, stops_aggregate: { __typename?: 'mobility_stops_aggregate', aggregate?: { __typename?: 'mobility_stops_aggregate_fields', count: number } | null } }> };


export const GetPartsDeliveryRunsDocument = gql`
    query getPartsDeliveryRuns($customerId: bigint!) {
  mobility_runs(
    where: {customer_id: {_eq: $customerId}, product_type: {_eq: "parts_delivery"}}
    order_by: [{departure_time: desc_nulls_last}, {created_at: desc}]
  ) {
    id
    status
    fulfillment_type
    parts_delivery {
      id
      vendor
      orchestration_status
      delivery_status
      fee_cents
      currency
      dropoff_eta
      tracking_url
      driver
      proof_of_delivery
      booked_at
      completed_at
      cancelation_reason
      last_error
      created_by
    }
    departure_time
    expected_return_time
    driver {
      id
      status
      user {
        display_name
        phone
      }
    }
    scenario {
      id
      bundletoscenarios(
        order_by: {bundle: {createdat: desc}}
        where: {bundle: {status: {_neq: "deprecated"}}}
        limit: 1
      ) {
        bundle {
          id
          status
          offers(order_by: {createdat: desc}) {
            id
            status
            driver {
              id
              status
              user {
                display_name
                phone
              }
            }
          }
        }
      }
    }
    vehicle {
      id
      year
      make
      model
      license_plate
    }
    stops(order_by: {stop_order: asc}) {
      id
      stop_order
      status
      address
      address_lat
      address_lng
      delivery_orders(order_by: {order_number: asc}) {
        id
        order_number
        recipient_business
        quantity
        status
        delivery_status
      }
    }
    stops_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetPartsDeliveryRunsQuery__
 *
 * To run a query within a React component, call `useGetPartsDeliveryRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartsDeliveryRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartsDeliveryRunsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetPartsDeliveryRunsQuery(baseOptions: Apollo.QueryHookOptions<GetPartsDeliveryRunsQuery, GetPartsDeliveryRunsQueryVariables> & ({ variables: GetPartsDeliveryRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartsDeliveryRunsQuery, GetPartsDeliveryRunsQueryVariables>(GetPartsDeliveryRunsDocument, options);
      }
export function useGetPartsDeliveryRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartsDeliveryRunsQuery, GetPartsDeliveryRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartsDeliveryRunsQuery, GetPartsDeliveryRunsQueryVariables>(GetPartsDeliveryRunsDocument, options);
        }
// @ts-ignore
export function useGetPartsDeliveryRunsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartsDeliveryRunsQuery, GetPartsDeliveryRunsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsDeliveryRunsQuery, GetPartsDeliveryRunsQueryVariables>;
export function useGetPartsDeliveryRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsDeliveryRunsQuery, GetPartsDeliveryRunsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsDeliveryRunsQuery | undefined, GetPartsDeliveryRunsQueryVariables>;
export function useGetPartsDeliveryRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsDeliveryRunsQuery, GetPartsDeliveryRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartsDeliveryRunsQuery, GetPartsDeliveryRunsQueryVariables>(GetPartsDeliveryRunsDocument, options);
        }
export type GetPartsDeliveryRunsQueryHookResult = ReturnType<typeof useGetPartsDeliveryRunsQuery>;
export type GetPartsDeliveryRunsLazyQueryHookResult = ReturnType<typeof useGetPartsDeliveryRunsLazyQuery>;
export type GetPartsDeliveryRunsSuspenseQueryHookResult = ReturnType<typeof useGetPartsDeliveryRunsSuspenseQuery>;
export type GetPartsDeliveryRunsQueryResult = Apollo.QueryResult<GetPartsDeliveryRunsQuery, GetPartsDeliveryRunsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/getPartsDeliveryRuns.query.gql}
 */
export async function getPartsDeliveryRuns(
  variables: GetPartsDeliveryRunsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetPartsDeliveryRunsQuery['mobility_runs']>
export async function getPartsDeliveryRuns(
  variables: GetPartsDeliveryRunsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetPartsDeliveryRunsQuery>
export async function getPartsDeliveryRuns(
  variables: GetPartsDeliveryRunsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetPartsDeliveryRunsQuery['mobility_runs'] | GetPartsDeliveryRunsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetPartsDeliveryRunsQuery>(
    GetPartsDeliveryRunsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.mobility_runs
}